<template>
  <v-dialog v-model="value" persistent width="500">
    <v-card>
      <v-card-title class="headline lighten-2" primary-title>
        {{ title }}
        <v-spacer></v-spacer>
        <v-icon color="gray">help</v-icon>
      </v-card-title>

      <v-card-text v-html="description"></v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">{{
          $t('generic.accept')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'title', 'description'],
  methods: {
    close() {
      this.$emit('input', !this.value)
    },
  },
}
</script>

<style></style>
